/**
 * Hand-curated article clusters that have their own hub page.
 *
 * The lists live here, not in the hub pages, so the article layout can use
 * them too: a post in a cluster points its inline Read next block at the
 * cluster's hub (/microplastics-in-coffee, /microplastics-in-water-bottles)
 * rather than the generic topic hub. Each hub page still throws at build if a
 * slug here stops existing in blogPosts; see the notes in those pages for why
 * each list includes what it does.
 */

export const COFFEE_SLUGS = [
  'microplastics-in-coffee',
  'microplastics-in-coffee-by-brewing-method',
  'do-k-cups-release-microplastics',
  'microplastics-in-k-cups-and-coffee-pods',
  'coffee-pods-brand-comparison-microplastics-2026',
  'best-reusable-k-cup-pods-stainless-steel-ranked',
  'nespresso-vertuo-vs-original-microplastics',
  'do-keurig-coffee-makers-have-microplastics',
  'do-ninja-coffee-makers-have-microplastics',
  'is-moccamaster-plastic-free',
  'best-plastic-free-coffee-makers',
  'microplastics-in-espresso-machines',
  'does-aeropress-leach-microplastics',
  'do-coffee-filters-have-microplastics',
  'microplastics-in-coffee-cups',
  'microplastics-in-coffee-creamer',
  'does-instant-coffee-have-microplastics',
  'does-starbucks-coffee-contain-microplastics',
  'does-dunkin-coffee-contain-microplastics',
  'microplastics-in-iced-coffee-brands-ranked-summer-2026',
]

export const DRINKWARE_SLUGS = [
  'refillable-water-bottle-materials-compared',
  'stanley-vs-yeti-vs-hydroflask-vs-owala-microplastics',
  'best-stainless-steel-water-bottles',
  'best-glass-water-bottles',
  'best-owala-water-bottles-microplastics',
  'is-owala-non-toxic',
  'does-hydroflask-have-microplastics',
  'does-yeti-have-microplastics',
  'are-stanley-cups-non-toxic-microplastic-audit',
  'are-nalgene-bottles-safe-microplastics',
  'does-cirkul-have-microplastics',
  'is-tritan-a-microplastic',
  'water-bottle-left-in-hot-car-microplastics',
  'best-kids-water-bottles-without-microplastics',
]

export interface ClusterHub {
  href: string
  label: string
}

const CLUSTERS: ReadonlyArray<{ hub: ClusterHub; slugs: readonly string[] }> = [
  { hub: { href: '/microplastics-in-coffee', label: 'Coffee: every brewing method and machine' }, slugs: COFFEE_SLUGS },
  { hub: { href: '/microplastics-in-water-bottles', label: 'Water bottles: every material and brand' }, slugs: DRINKWARE_SLUGS },
]

/** The hub of the cluster a post belongs to, if any. */
export function clusterHubFor(slug: string): ClusterHub | undefined {
  return CLUSTERS.find((c) => c.slugs.includes(slug))?.hub
}
